import TransactionWorkspace from "./TransactionWorkspace.jsx";
import CreateDraft from "./create/CreateDraft.jsx";
import {serverHost} from "../../../../http_common.js";
import {useReactToPrint} from "react-to-print";
import {transactionSummary,transactionDetails,purchaseAmount,purchaseDate} from "./exports/SalesPDFExport.jsx";
import {matchesPurchaseFilters} from "./filters/FilterOders.jsx";
import {TransactionRecordPreview} from "./previews/PreviewSales.jsx";
import {useState,useEffect,useRef,useMemo,useCallback} from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import "./drafts.css";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import * as Action from "../../../../store/redux/client_reducer.js";
import { useSnackbar } from "notistack";
// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

import IsLoading from "../../../../IsLoading.jsx";
import FilterDrafts from "./filters/FilterDrafts.jsx";
import ExportPDFButton from "./exports/DraftsPDFExport.jsx";
import ExportExcelJSButton from "./exports/DraftsExcelExport.jsx";
// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

// import from MUI
import ShortTextIcon from "@mui/icons-material/ShortText";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import ScreenShareOutlinedIcon from "@mui/icons-material/ScreenShareOutlined";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ListAltIcon from "@mui/icons-material/ListAlt";
import PrintIcon from "@mui/icons-material/Print";
import FlightIcon from "@mui/icons-material/Flight";
import PlaceIcon from "@mui/icons-material/Place";
import AppsOutlinedIcon from "@mui/icons-material/AppsOutlined";
import AddIcon from "@mui/icons-material/Add";
import CandlestickChartIcon from "@mui/icons-material/CandlestickChart";
// image imports


export default function Drafts({ breadcrumbs, data, setIsMobileNavOpen }) {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [changeview, setChangeView] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalInfo, setModalInfo] = useState("");
  const [displayedComponent, setDisplayedComponent] = useState("main-display");
  const [soldPayload, setsoldPayload] = useState(null);

  // Paginations Functions
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [openLimit, setOpenLimit] = useState(false);
  const [draftData,setRawRecords]=useState([]),[filters,setFilters]=useState({rules:[],sort:'newest',from:'',to:''}),[requestError,setRequestError]=useState('');
  const currentTab=useSelector(state=>state.clientFunction?.dashboard?.currentTab),serial=useRef(0),pending=useRef(false),listPrintRef=useRef(null),activeCompany=useRef(data?.clientId);activeCompany.current=data?.clientId;
  const printList=useReactToPrint({contentRef:listPrintRef,documentTitle:'Drafts'});
  const summarizedRecords=useMemo(()=>draftData.map(record=>({record,summary:transactionSummary(record,'draft')})),[draftData]);
  const summaryByRecord=useMemo(()=>new Map(summarizedRecords.map(({record,summary})=>[record,summary])),[summarizedRecords]);
  const filteredData=useMemo(()=>summarizedRecords.filter(({summary:s})=>{if(currentTab==='completed'&&!['completed','complete','posted','delivered','paid','recorded','cancelled','void','archived','accepted','rejected'].includes(String(s.status).toLowerCase()))return false;if(currentTab==='progress'&&(s.status==='Not recorded'||['completed','complete','posted','delivered','paid','recorded','cancelled','void','archived','accepted','rejected'].includes(String(s.status).toLowerCase())))return false;return matchesPurchaseFilters({...s,supplier:s.customer,warehouse:s.inventory,orderId:s.reference},filters);}).sort((a,b)=>{const left=a.summary,right=b.summary;if(filters.sort==='amount-high'||filters.sort==='amount-low')return ((left.amount??-Infinity)-(right.amount??-Infinity))*(filters.sort==='amount-high'?-1:1);const diff=(new Date(right.date||0).getTime()||0)-(new Date(left.date||0).getTime()||0);return filters.sort==='oldest'?-diff:diff;}).map(({record}) => record),[summarizedRecords,filters,currentTab]);
  const totalPages=Math.max(1,Math.ceil(filteredData.length/rowsPerPage)),start=(currentPage-1)*rowsPerPage,end=start+rowsPerPage,currentRows=filteredData.slice(start,end);
  useEffect(()=>{setCurrentPage(1);},[filters,currentTab]);useEffect(()=>{setCurrentPage(page=>Math.min(page,totalPages));},[totalPages]);

  function apiGetDrafts(signal){return loadRecords(signal);}
  const loadRecords=useCallback(async(signal)=>{if(!data?.clientId)return;const request=++serial.current;setLoading(true);setRequestError('');try{const response=await axios.get(`${serverHost}/inventory/client/${encodeURIComponent(data.clientId)}/drafts`,{signal});if(![200,201].includes(response.data.status))throw new Error(response.data.message||'Records could not be loaded.');if(!signal?.aborted&&request===serial.current)setRawRecords(Array.isArray(response.data.drafteds)?response.data.drafteds:[]);}catch(error){if(!signal?.aborted&&request===serial.current){setRawRecords([]);setRequestError(error.response?.data?.message||error.message);}}finally{if(!signal?.aborted&&request===serial.current)setLoading(false);}},[data?.clientId]);
  useEffect(()=>{const controller=new AbortController();setRawRecords([]);setsoldPayload(null);setModalOpen(false);loadRecords(controller.signal);return()=>controller.abort();},[loadRecords]);
  const closeModal=()=>{setModalOpen(false);setModalInfo('');},openPreview=record=>{setsoldPayload(record);setModalInfo('previewAlpha');setModalOpen(true);},editRecord=record=>{setsoldPayload(record);setModalInfo('edit');setModalOpen(true);},savedRecord=record=>{if(record?.clientId&&record.clientId!==activeCompany.current)return;closeModal();setDisplayedComponent('main-display');setsoldPayload(record);loadRecords();};
  async function updateStatus(record,status){if(pending.current)return;pending.current=true;setLoading(true);try{const response=await axios.post(`${serverHost}/client/${encodeURIComponent(data.clientId)}/point_of_sales/save_draft`,{action:'STATUS',["draftId"]:record['draftId']||(record.code||''),inventoryId:record.inventoryId,expectedRevision:record.revision||0,status});if(![200,201].includes(response.data.status))throw new Error(response.data.message);if(activeCompany.current!==data.clientId)return;setsoldPayload(response.data.savedRecord||response.data.info);loadRecords();}catch(error){enqueueSnackbar(error.response?.data?.message||error.message,{variant:'error'});}finally{pending.current=false;setLoading(false);}}
  function applyPeriod(mode){const from=new Date();if(mode==='This Week')from.setDate(from.getDate()-6);if(mode==='This Month')from.setDate(1);if(mode==='This year')from.setMonth(0,1);setFilters(current=>({...current,from:from.toISOString().slice(0,10),to:new Date().toISOString().slice(0,10)}));}
  const {completedCount,progressCount}=useMemo(()=>{
    let completedCount=0, recordedCount=0;
    summarizedRecords.forEach(({summary}) => {
      const status=String(summary.status).toLowerCase();
      if (['completed','complete','posted','delivered','paid','recorded','cancelled','void','archived','accepted','rejected'].includes(status)) completedCount++;
      if (summary.status !== 'Not recorded') recordedCount++;
    });
    return {completedCount,progressCount:recordedCount-completedCount};
  },[summarizedRecords]);
  const resumeDraft=record=>{sessionStorage.setItem('universe-pending-draft',JSON.stringify({clientId:data.clientId,draftId:record.draftId,inventoryId:record.inventoryId}));window.open('/clients/workspace/terminal-login','_blank');};
  // /////////////////////////////////////////////////////////
  // Redux functions for sub-navigation
  // /////////////////////////////////////////////////////////
  function handleCurrentTAB(item) {
    dispatch(DispatchCurrentTAB(item));
  }
  const DispatchCurrentTAB = (item) => async (dispatch) => {
    try {
      dispatch(Action.dispatchCurrentTAB({ item }));
    } catch (error) {
      console.log(error?.code || "REQUEST_FAILED");
    }
  };
  function handlePrint(){printList();}
  const DispatchPrinting = (data) => async (dispatch) => {
    try {
      dispatch(Action.dispatchPrintData({ data }));
    } catch (error) {
      console.log(error?.code || "REQUEST_FAILED");
    }
  };

  // ////////////////////////////////////////////////////////////
  function getPagination(current, total) {
    if (total <= 7) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }

    if (current <= 4) {
      return [1, 2, 3, 4, 5, "...", total];
    }

    if (current >= total - 3) {
      return [1, "...", total - 4, total - 3, total - 2, total - 1, total];
    }

    return [1, "...", current - 1, current, current + 1, "...", total];
  }

  function switchActiveTab(){return <ToDo/>;}

  const printElement=()=>printList();
  // //////////////////////////////////////////////////////////////////////////
  // COMPONENTS OF drafts PAGE
  // //////////////////////////////////////////////////////////////////////////

  function ToDo() {
    function switchView() {
      switch (changeview) {
        case "grid":
          return <CardView currentRows={currentRows} />;
        case "table":
          return <TableView currentRows={currentRows} />;
        default:
          return <TableView currentRows={currentRows} />;
      }
    }
    function TableView({currentRows}){return <div className="products"><table className="fx-cl spacem"><thead className="fx-cl spacem"><tr>{['Record ID','Name / Customer','Inventory','Status','Created','Units','Recorded value','Action'].map(title=><th key={title}>{title}</th>)}</tr></thead><tbody className="fx-cl spacem">{currentRows.map(record=>{const summary=transactionSummary(record,'draft');return <tr key={String(record._id||summary.id)} className="productsRowTdCont fx-cl space1"><td className="productsRowTd" onClick={()=>openPreview(record)}><span><strong>{String(summary.id)}</strong></span><span>{summary.customer}</span><span>{summary.inventory}</span><span>{summary.status}</span><span>{purchaseDate(summary.date)}</span><span>{summary.quantity}</span><span>{purchaseAmount(summary.amount,summary.currency)}</span><span><button className="controlButtons" onClick={event=>{event.stopPropagation();openPreview(record);}}>View</button></span></td></tr>;})}</tbody></table></div>;}

    function CardView({currentRows}){return <div className="draftsCardGrid g g4 space2">{currentRows.map(record=>{const summary=transactionSummary(record,'draft');return <div key={String(record._id||summary.id)} className="draftsGridCard"><div className="cardHeader"><figure className="avatar fx-ac fx-jc"><ReceiptLongIcon style={{fontSize:'3rem'}}/></figure><div className="cardInfo"><h4>{summary.customer}</h4><p>{String(summary.id)}</p><div className="ratingRow"><span className="rating">{summary.status}</span><span className="location">{purchaseDate(summary.date)}</span></div><small>{summary.inventory}</small></div></div><div className="tags">{transactionDetails(record,'draft').slice(1,4).map(([key,value])=><span key={key}>{key}: {value}</span>)}</div><div className="cardFooter"><span className="price">{purchaseAmount(summary.amount,summary.currency)}</span><button className="cardBtn" onClick={()=>openPreview(record)}>View</button></div></div>;})}</div>;}
    return (
      <div className="fx-cl space2">
        <div className="fx-cl space2">
          <div className="fx-cl spacem">
            <div className="fx-ac fx-jb space2" style={{ fontSize: "1.2rem" }}>
              <span className="fx-ac spacem">
                <strong className="fx-jc" style={{ color: "#3a84f8" }}>
                  Display:
                </strong>
                <span>
                  {draftData?.length === 0
                    ? "0 to 0 of 0 entries"
                    : `${start + 1} to ${Math.min(
                        end,
                        draftData?.length,
                      )} of ${draftData?.length} entries`}
                </span>
              </span>
              <div className="drafts_entries-info fx-ac spacem">
                <h4>Rows</h4>
                <div className="drafts-page-limit">
                  <button
                    className="drafts-page-limit-btn"
                    onClick={() => setOpenLimit(!openLimit)}
                  >
                    {rowsPerPage} / page
                    <span className="drafts-page-limit-arrow">▾</span>
                  </button>

                  {openLimit && (
                    <ul className="drafts-limit-dropdown">
                      {[10, 20, 50, 100, 200, 500, 1000].map((n) => (
                        <li
                          key={n}
                          className="drafts-limit-item"
                          onClick={() => {
                            setRowsPerPage(n);
                            setCurrentPage(1);
                            setOpenLimit(false);
                          }}
                        >
                          {n} / page
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
            <div className="drafts_row" id="printable">
              {switchView()}
            </div>
            <div className="fx-jc">
              <div className="drafts_pagination fx-ac space2">
                <button
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((p) => p - 1)}
                >
                  Previous
                </button>
                <div className="fx-ac">
                  {getPagination(currentPage, totalPages).map((page, i) =>
                    page === "..." ? (
                      <span key={i} className="dots">
                        …
                      </span>
                    ) : (
                      <button
                        key={i}
                        className={`drafts_jumpto ${
                          currentPage === page ? "active" : ""
                        }`}
                        onClick={() => setCurrentPage(page)}
                      >
                        {page}
                      </button>
                    ),
                  )}
                </div>

                <button
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((p) => p + 1)}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  function Completed(){return <ToDo/>;}
  function Progress(){return <ToDo/>;}

  function handleModalFunction(toggleModal, displayModal) {
    setModalInfo(displayModal);
    setModalOpen(toggleModal);
  }
  function loopingModalInfo(){switch(modalInfo){case 'filters':return <FilterDrafts filters={filters} onApply={setFilters} onClose={closeModal} currentRows={filteredData}/>;case 'previewAlpha':return <TransactionRecordPreview premium record={soldPayload} kind="draft" onClose={closeModal} busy={loading} onEdit={editRecord} onResume={resumeDraft} onStatus={updateStatus}/>;case "create":return <CreateDraft onCreated={savedRecord} onClose={closeModal}/>;case "edit":return <CreateDraft initialRecord={soldPayload} onCreated={savedRecord} onClose={closeModal}/>;default:return null;}}
  function MobileUi({ setIsMobileNavOpen }) {
    const [showCard, setShowCard] = useState("");
    const cardRef = useRef(null);

    // Close when clicking outside
    useEffect(() => {
      const handleClickOutside = (e) => {
        if (cardRef.current && !cardRef.current.contains(e.target)) {
          setShowCard("");
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);
    return (
      <div
        id="mobileRWDInvDisp"
        className="salesMobileUi computerRWDhide fx-cl space3"
      >
        <div className="fx-ac fx-jb space2">
          <button onClick={() => setIsMobileNavOpen(true)}>
            <ShortTextIcon style={{ color: "#818181", fontSize: "3.8rem" }} />
          </button>
          <div className="fx-cl">
            <span className="fs3 fw500">Transactions</span>
            {/* <span className="fs1 fw200">Lorem ipsum dolor sit amet cons</span> */}
          </div>
          <div className="fx-ac fx-jc spacem" style={{ color: "#818181" }}>
            <figure role="button" tabIndex={0} onClick={printList} onKeyDown={event=>{if(event.key==="Enter")printList();}}>
              <PrintOutlinedIcon style={{ fontSize: "3.8rem" }} />
            </figure>
            <div className="fx" style={{ position: "relative" }}>
              <button
                className="fw600 fs1"
                onClick={() => setShowCard("exports")}
              >
                <ScreenShareOutlinedIcon style={{ fontSize: "3.8rem" }} />
              </button>

              {showCard === "exports" && (
                <div ref={cardRef} className="exportsBtnDropdwn fx-cl">
                  <button className="fx-ac spacem">
                    <ExportPDFButton currentRows={filteredData} />
                    <span>Export to Pdf</span>
                  </button>
                  <ExportExcelJSButton currentRows={filteredData} />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="fx-cl spacem">
          <div className="fx-ac fx-jb space3">
            <span className="lightGrayMbl fx-jc fs1">
              {filteredData.length === 0
                ? "0 to 0 of 0 entries"
                : `${start + 1} - ${Math.min(
                    end,
                    filteredData.length,
                  )} of ${filteredData.length} `}
            </span>
            <div className="fx" style={{ position: "relative" }}>
              <button
                className="fw600 fs1"
                style={{ color: "#3a84f8" }}
                onClick={() => setShowCard("transactions")}
              >
                All transactions
              </button>

              {showCard === "transactions" && (
                <div ref={cardRef} className="exportsBtnDropdwn fx-cl">
                  <button className="fx-ac spacem" onClick={()=>{applyPeriod('Today');setShowCard('');}}>Today</button>
                  <button className="fx-ac spacem" onClick={()=>{applyPeriod('This Week');setShowCard('');}}>This Week</button>
                  <button className="fx-ac spacem" onClick={()=>{applyPeriod('This Month');setShowCard('');}}>This Month</button>
                  <button className="fx-ac spacem" onClick={()=>{applyPeriod('This Month');setShowCard('');}}>This Month</button>
                  <button className="fx-ac spacem" onClick={()=>{applyPeriod('This year');setShowCard('');}}>This year</button>
                </div>
              )}
            </div>
          </div>
          <div className="mobileUiItemsCont fx-cl space1">
            {currentRows.map(record=>{const summary=transactionSummary(record,'draft');return <div className="mobileUiItemCard fx-cl" key={String(record._id||summary.id)}><div className="topContents fx-ac space2"><figure className="mblImgCard"><InsertDriveFileIcon style={{fontSize:'3.7rem'}}/></figure><div className="fx-cl spacem" style={{flexGrow:1}}><span className="fw500">Drafts: {summary.id}</span><span className="fs1 lightGrayMbl">{summary.customer}</span><div className="fx-jb fx-ac"><span className="fw500 fs4">{purchaseAmount(summary.amount,summary.currency)}</span><span className="fs1v lightGrayMbl">{summary.status}</span></div></div></div><div className="bottomConts fx-ac space3 fx-jb"><div className="fx-cl spacem"><span className="fs1 lightGrayMbl">Inventory: {summary.inventory}</span><span className="fs3 fw500">{purchaseDate(summary.date)}</span></div><div className="fx spacem"><button onClick={()=>openPreview(record)}>View Record</button></div></div></div>;})}
          </div>
          <div className="fx-jc">
            <div className="sales_pagination fx-ac space2">
              <button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((p) => p - 1)}
              >
                Previous
              </button>
              <div className="fx-ac">
                {getPagination(currentPage, totalPages).map((page, i) =>
                  page === "..." ? (
                    <span key={i} className="dots">
                      …
                    </span>
                  ) : (
                    <button
                      key={i}
                      className={`sales_jumpto ${
                        currentPage === page ? "active" : ""
                      }`}
                      onClick={() => setCurrentPage(page)}
                    >
                      {page}
                    </button>
                  ),
                )}
              </div>

              <button
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((p) => p + 1)}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function MainUi() {
    return <TransactionWorkspace
      kind="draft"
      records={filteredData}
      summaryByRecord={summaryByRecord}
      filters={filters}
      onFiltersChange={setFilters}
      onAdvancedFilter={() => handleModalFunction(true, "filters")}
      onRefresh={() => loadRecords()}
      onPreview={openPreview}
      
      
      loading={loading}
      error={requestError}
      view={changeview}
      onViewChange={setChangeView}
      tabs={[{value:"drafts",label:"All drafts"}, {value:"completed",label:"Completed"}, {value:"progress",label:"In progress"}]}
      activeTab={currentTab}
      onTabChange={handleCurrentTAB}
      printRef={listPrintRef}
      onPrint={printList}
      renderExcel={records => <ExportExcelJSButton currentRows={records} />}
    />;
  }

  function controlDisplay() {
    switch (displayedComponent) {
      case "main-display":
        return MainUi();
      case "item-previewed":
        return <TransactionRecordPreview premium record={soldPayload} kind="draft" onClose={()=>setDisplayedComponent("main-display")}/>;
      default:
        return MainUi();
    }
  }

  return (
    <div className="draftsCompContainer">


      {modalOpen && (
        <div
          className="client_modal_overlay fx-jc fx-ac"
          onClick={() => handleModalFunction(false, "")} // click outside → close
        >
          <div
            className="client_modal"
            onClick={(e) => e.stopPropagation()} // click inside → stay open
          >
            {loopingModalInfo()}
          </div>
        </div>
      )}
      {controlDisplay()}
    </div>
  );
}
